import React from "react";

const WaitingMessageComponent = ({ message }) => {
  return (
    <div className="container my-3">
      <div>
        <h4 className="text-danger text-center"> {message}</h4>
      </div>
    </div>
  );
};

export default WaitingMessageComponent;
